import { render, staticRenderFns } from "./AnHeading.vue?vue&type=template&id=2d9f6785&"
import script from "./AnHeading.vue?vue&type=script&lang=js&"
export * from "./AnHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports